import React from 'react';
import { createRoot } from 'react-dom/client';
import { FinancialViewNav } from './FinancialViewNav';
import './styles.css';
const container = document.getElementById('financial-view');

if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <FinancialViewNav />
    </React.StrictMode>
  );
} else {
  console.error('Error: El contenedor raíz para la aplicación React no fue encontrado.');
}
